var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDarSubTask = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10,
  fill: "#7BC9FF"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.625 10.75H13.375C13.5739 10.75 13.7647 10.671 13.9053 10.5303C14.046 10.3897 14.125 10.1989 14.125 10V8.5C14.125 8.30109 14.046 8.11032 13.9053 7.96967C13.7647 7.82902 13.5739 7.75 13.375 7.75H9.625C9.42609 7.75 9.23532 7.82902 9.09467 7.96967C8.95402 8.11032 8.875 8.30109 8.875 8.5V8.875H7.375V5.5H8.125C8.22446 5.5 8.31984 5.46049 8.39016 5.39017C8.46049 5.31984 8.5 5.22446 8.5 5.125C8.5 5.02554 8.46049 4.93016 8.39016 4.85983C8.31984 4.78951 8.22446 4.75 8.125 4.75H5.875C5.77554 4.75 5.68016 4.78951 5.60984 4.85983C5.53951 4.93016 5.5 5.02554 5.5 5.125C5.5 5.22446 5.53951 5.31984 5.60984 5.39017C5.68016 5.46049 5.77554 5.5 5.875 5.5H6.625V13C6.625 13.2984 6.74353 13.5845 6.9545 13.7955C7.16548 14.0065 7.45163 14.125 7.75 14.125H8.875V14.5C8.875 14.6989 8.95402 14.8897 9.09467 15.0303C9.23532 15.171 9.42609 15.25 9.625 15.25H13.375C13.5739 15.25 13.7647 15.171 13.9053 15.0303C14.046 14.8897 14.125 14.6989 14.125 14.5V13C14.125 12.8011 14.046 12.6103 13.9053 12.4697C13.7647 12.329 13.5739 12.25 13.375 12.25H9.625C9.42609 12.25 9.23532 12.329 9.09467 12.4697C8.95402 12.6103 8.875 12.8011 8.875 13V13.375H7.75C7.65054 13.375 7.55516 13.3355 7.48484 13.2652C7.41451 13.1948 7.375 13.0995 7.375 13V9.625H8.875V10C8.875 10.1989 8.95402 10.3897 9.09467 10.5303C9.23532 10.671 9.42609 10.75 9.625 10.75Z",
  fill: "white"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDarSubTask);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dar_sub_task.cb0e578ad3a6703de8606ae7e7a3d53c.svg";